// extracted by mini-css-extract-plugin
var _1 = "EmailAttachedThreadsModalTableRow-moduleEmailAttachedThreadsModalTableRow__P4B4V TableComponent-modulerow__xPAo4";
var _2 = "EmailAttachedThreadsModalTableRow-modulereadonly__ktgU7";
export { _1 as "EmailAttachedThreadsModalTableRow", _2 as "readonly" }
